// extracted by mini-css-extract-plugin
export default {"authorization-page":"styles_authorization-page__8JO+K"};